const component = {
  bindings: {
    cause: '<',
  },
  template: `
  <div class="ourpartners">
    <h1 class="ourpartners--header">Help <b>gogreenback</b> bring benefit to everyone.</h1>
    <div class="ourpartners__img"><img src="//cdn.startupmedia.com/gb/imgs/global/gb/icon-diagram-6.png"></div>
    <div class="ourpartners__boxes">
      <div class="ourpartners__box">
        <h2 class="box__header">How can my favorite merchants become providers in <b>gogreenback</b>?</h2>
        <p>Tell your favorite retailers, restaurants and service providers about how to place offers in gogreenback.</p>
        <br>
        <div class="box__btn popup--trigger" ng-click="$ctrl.isShown = true">Invite a Provider</div>
      </div>
      <div class="ourpartners__box">
        <h2 class="box__header">How can I refer my family and friends to become a member of <b>gogreenback</b>?</h2>
        <p>Click below to send an email telling your friends and family how to join <b>gogreenback</b> and bring benefit to everyone.</p><br>
        <div class="box__btn"><a href="mailto:?subject=Check%20out%20gogreenback!&body=Check%20out%20gogreenback!%20It%E2%80%99s%20a%20new%20savings%20program%20that%20brings%20benefit%20to%20everyone%20and%20provides%20members%20with%20over%20350%2C000%20merchant%20offers%20nationwide.%20%0A%0AIt%E2%80%99s%20Simple.%20%0A1.%20Join%20gogreenback%20by%20purchasing%20a%20membership%20and%20you%20can%20save%20hundreds%20if%20not%20thousands%20of%20dollars%2C%20annually.%20%0A2.%20Confirm%20the%20cause%20you%20support%20and%20a%20portion%20of%20your%20membership%20fee%20goes%20to%20the%20cause.%20%0A3.%20Access%20your%20membership%20on%20your%20desktop%20%20or%20mobile%20device%20and%20start%20saving%20today.%20%0A%0AJoin%20now!%0A%0Ahttp%3A%2F%2F{{$ctrl.cause.referUrl}}">Refer a Friend</a></div>
      </div>
      <div class="ourpartners__box" ng-if="$ctrl.cause.id == $ctrl.startupSponsorId">
        <h2 class="box__header">How can I see my favorite cause benefit from the <b>gogreenback</b> program?</h2>
        <p>Click below to send an email to your favorite charitable organization about how they can become a registered cause in <b>gogreenback</b>.</p>
        <div class="box__btn"><a href="mailto:?subject=Check%20out%20gogreenback!&body=Hi%2C%0A%0AI%E2%80%99m%20a%20member%20of%20gogreenback%2C%20a%20nation-wide%20savings%20program%20that%20rewards%20donors%20for%20supporting%20great%20causes.%20I%20would%20really%20like%20to%20see%20your%20organization%20become%20part%20of%20the%20gogreenback%20system%20as%20a%20registered%20cause.%20As%20a%20registered%20cause%2C%20your%20organization%20can%20use%20gogreenback%20to%20increase%20donations.%20I%20personally%20support%20your%20cause%20and%20I%20believe%20that%20gogreenback%20would%20bring%20benefit%20to%20you!%0A%0APlease%20visit%20http%3A%2F%2Fwww.getgreenback.com%20and%20see%20why%20I%20think%20you%20should%20be%20a%20part%20of%20the%20program%20that%20brings%20benefit%20to%20everyone.">Invite a Cause</a></div>
    </div>
  </div>

  <div class="popup" ng-class="$ctrl.isShown ? 'popup--is-shown' : ''">
    <p>Tell your favorite merchants to contact us at <a href="mailto:provider@gogreenback.com">provider@gogreenback.com</a> and we’ll take care of the rest!</p>
    <div class="popup__ok" ng-click="$ctrl.isShown = false">ok</div>
  </div>
`,
  controller(ConfigEnvironment) {
    "ngInject";

    this.$onInit = () => {
      console.log('__ourpartners__');
      this.isShown = false;
      this.genericSponsorId = ConfigEnvironment.getConfiguration("generic_sponsor_id");
      this.startupSponsorId = ConfigEnvironment.getConfiguration('startup_sponsor_id');
      this.cause.referUrl = (this.cause.id === this.genericSponsorId || !this.cause.subdomain) ?
        'getgreenback.com' :
        `${this.cause.subdomain}.${this.cause.is_sponsor ? 'sponsor' : 'cause'}.gogreenback.com`;
    }
  }
};

export default component;



// WEBPACK FOOTER //
// ./js/containers/sponsorPortal/ourpartners.component.js